import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EmailTemplate } from '@shared/models';

import { ApiService } from './api.service';

@Injectable()
export class EmailTemplatesService extends ApiService<EmailTemplate> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'greenhouse/email-templates/';
  }
}
